






























































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from '@/core/base.component';
import { CodeManagementDto } from '@/services/init/dto';
import { GENDER, CONST_GENDER } from '../../../services/shared';
import CodeManagementService from '@/services/code-management.service';
import FounderConsultService from '@/services/founder-consult.service';
import AdminService from '@/services/admin.service';
import FoodCategoryService from '@/services/food-category.service';
import FounderConsultManagementService from '@/services/founder-consult-management.service';
import SmsService from '@/services/sms.service';

import {
  AdminSendMessageDto,
  FoodCategoryDto,
  FoodCategoryListDto,
  AdminDto,
  AdminListDto,
  FounderConsultDto,
  FounderConsultUpdateDto,
  FounderConsultManagementDto,
} from '@/dto';
import { Pagination, YN, CONST_YN } from '@/common';
import { BaseUser } from '@/services/shared/auth';
import BaseCard from '../../_components/BaseCard.vue';
import FounderConsultManagementHistory from './FounderConsultManagementHistory.vue';
import toast from '../../../../resources/assets/js/services/toast.js';
import { FOUNDER_CONSULT, CONST_FOUNDER_CONSULT } from '@/services/shared';
import { getStatusColor } from '@/core';

import {
  ProductionEnvironment,
  DevelopmentEnvironment,
  EnvironmentType,
  Environment,
} from '../../../../environments';

let env = new Environment();
if (process.env.NODE_ENV === EnvironmentType.development) {
  env = DevelopmentEnvironment;
}
if (process.env.NODE_ENV === EnvironmentType.production) {
  env = ProductionEnvironment;
}

@Component({
  name: 'FounderConsultDetail',
  components: {
    BaseCard,
    FounderConsultManagementHistory,
  },
})
export default class FounderConsultDetail extends BaseComponent {
  /* global kakao */

  private adminList: AdminDto[] = [];
  private adminListDto = new AdminListDto();
  private adminListCount = 0;
  private availableTimesSelect: CodeManagementDto[] = [];
  private delYn: YN[] = [...CONST_YN];
  private founderConsultDto = new FounderConsultDto();
  private founderConsultUpdateDto = new FounderConsultUpdateDto();
  private founderConsultStatusSelect: CodeManagementDto[] = [];
  private genderSelect: CodeManagementDto[] = [];
  private foodCategorySelect: FoodCategoryDto[] = [];
  private pagination = new Pagination();
  private selectedAdmin: AdminDto = new AdminDto(BaseUser);
  private founderConsultManagements: FounderConsultManagementDto[] = [];
  private elapsedTime = null;
  private deliveredTime = new Date();
  private createdTime = new Date();
  private adminSendMessageDto = new AdminSendMessageDto();
  private homepageBaseUrl = env.homepageBaseUrl;
  private homepageSiteUrl = env.homepageSiteUrl;

  // get status color
  getStatusColor(status: FOUNDER_CONSULT) {
    return getStatusColor(status);
  }

  // 사용자 정보 수정
  // updateNanudaUser() {
  //   if (this.founderConsultDto.nanudaUser.gender) {
  //     this.founderConsultUpdateDto.gender = this.founderConsultDto.nanudaUser.gender;
  //   }
  //   this.getGender();
  // }

  // send message to user
  sendMessage() {
    this.adminSendMessageDto.phone = this.founderConsultDto.nanudaUser.phone;
    SmsService.sendMessage(this.adminSendMessageDto).subscribe(res => {
      if (res) {
        this.adminSendMessageDto = new AdminSendMessageDto();
        toast.success('문자가 발송 되었습니다.');
      } else {
        return;
      }
    });
  }

  // 지도 가져오기
  setMap(founderConsult: FounderConsultDto) {
    const mapContainer = document.getElementById('map'),
      mapOption = {
        center: new window.kakao.maps.LatLng(
          founderConsult.space.lat,
          founderConsult.space.lon,
        ),
        level: 5,
        maxLevel: 6,
        minLevel: 3,
        mapTypeId: window.kakao.maps.MapTypeId.ROADMAP,
      };

    const map = new window.kakao.maps.Map(mapContainer, mapOption);
    const content = `<span class="badge badge-primary" style="font-size:21px;border-radius: 100px;opacity: 82%">Here</span>`;
    const markerPosition = new window.kakao.maps.LatLng(
      founderConsult.space.lat,
      founderConsult.space.lon,
    );

    const customOverlay = new window.kakao.maps.CustomOverlay({
      position: markerPosition,
      content: content,
      // image: markerImage,
    });

    const circle = new window.kakao.maps.Circle({
      map: map,
      center: new window.kakao.maps.LatLng(
        founderConsult.space.lat,
        founderConsult.space.lon,
      ),
      strokeWeight: 2,
      strokeColor: '#FF00FF',
      strokeOpacity: 0.8,
      strokeStyle: 'dashed',
      fillColor: '#00EEEE',
      fillOpacity: 0.5,
    });
    circle.setRadius(400);
    circle.setMap(map);
    customOverlay.setMap(map);
  }

  // 상담 내용 수정
  // updateConsultInfo() {
  //   this.founderConsultUpdateDto = this.founderConsultDto;
  //   this.getFounderConsultCodes();
  //   this.getAvailableTimes();
  //   this.getFoodCategories();
  //   this.getGender();
  // }

  reverseReadStatus() {
    FounderConsultService.reverseReadStatus(this.$route.params.id).subscribe(
      res => {
        this.findOne(this.$route.params.id);
      },
    );
  }

  // 성별
  getGender() {
    CodeManagementService.findGender().subscribe(res => {
      this.genderSelect = res.data;
    });
  }

  // 희망 상담 시간
  getAvailableTimes() {
    CodeManagementService.findAvailableTimes().subscribe(res => {
      this.availableTimesSelect = res.data;
    });
  }

  // 신청 상태 코드
  getFounderConsultCodes() {
    CodeManagementService.findCodesFounderConsult().subscribe(res => {
      this.founderConsultStatusSelect = res.data;
    });
  }

  // 상담 메모 management
  getFounderConsultManagements(id) {
    FounderConsultManagementService.findForManagement(id).subscribe(res => {
      if (res) {
        this.founderConsultManagements = res.data;
      }
    });
  }

  findOne(id) {
    // find founder consult detail
    FounderConsultService.findOne(id).subscribe(res => {
      this.founderConsultDto = res.data;
      this.deliveredTime = res.data.deliveredAt;
      this.setMap(res.data);
      if (this.deliveredTime) {
        this.createdTime = new Date(res.data.createdAt);
        this.deliveredTime = new Date(res.data.deliveredAt);
        this.getElapsedTime(this.createdTime, this.deliveredTime);
      }
    });
  }

  // 경과 시간
  getElapsedTime(startTime, endTime) {
    const timeDiff = Math.abs(
      (this.deliveredTime as any) - (this.createdTime as any),
    );
    const inMinutes = 60 * 1000;
    const inHours = 36e5;

    if (timeDiff > inHours) {
      this.elapsedTime = Math.ceil(timeDiff / inHours) + '시간';
    } else {
      this.elapsedTime = Math.ceil((timeDiff % inHours) / inMinutes) + '분';
    }
  }

  paginateSearch() {
    this.findAdmin(true);
  }

  selectAdmin(admin: AdminDto) {
    this.selectedAdmin = admin;
  }

  cancelSelection() {
    this.selectedAdmin = new AdminDto(BaseUser);
  }

  findAdmin(isPagination: boolean) {
    if (!isPagination) {
      this.pagination.page = 1;
    }
    this.pagination.limit = 5;
    AdminService.findAll(this.adminListDto, this.pagination).subscribe(res => {
      this.adminList = res.data.items;
      this.adminListCount = res.data.totalCount;
    });
  }

  // 음식 업종
  getFoodCategories() {
    FoodCategoryService.findForSelect().subscribe(res => {
      this.foodCategorySelect = res.data;
    });
  }

  // 담당자 본인으로 정하기
  assignYourselfAdmin() {
    FounderConsultService.assignAdmin(this.founderConsultDto.no).subscribe(
      res => {
        this.findOne(this.founderConsultDto.no);
      },
    );
  }

  updateFounderConsult() {
    if (this.selectedAdmin) {
      this.founderConsultDto.spaceConsultManager = this.selectedAdmin.no;
    }

    if (this.founderConsultDto.nanudaUser.gender) {
      this.founderConsultDto.gender = this.founderConsultDto.nanudaUser.gender;
    }

    FounderConsultService.update(
      this.founderConsultDto.no,
      this.founderConsultDto,
    ).subscribe(res => {
      this.cancelSelection();
      // this.founderConsultUpdateDto = new FounderConsultUpdateDto();
      this.findOne(this.founderConsultDto.no);
      toast.success('수정완료');
    });
  }

  created() {
    this.findOne(this.$route.params.id);
    this.getFounderConsultCodes();
    this.getFoodCategories();
    this.getGender();
  }
}
